import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { navigationItems, topNavigationItems, INavigationItem } from './navigation.items';

@Module({ namespaced: true, dynamic: true, store, name: 'NavigationModule' })
class NavigationState extends VuexModule {
	showSideNavigation: boolean = true;
	navigationItems: readonly INavigationItem[] = Object.freeze(navigationItems);
	topNavigationItems: readonly INavigationItem[] = Object.freeze(topNavigationItems);

	@Mutation
	ToggleSideNavigation() {
	    this.showSideNavigation = !this.showSideNavigation;
	}

	@Mutation
	SetSideNavigationStatus(status: boolean) {
	    this.showSideNavigation = status;
	}

	@Mutation
	Reset() {}

	@Action({ rawError: true })
	Clear() {
	    this.Reset();
	}

	@Action({ rawError: true })
	async Init() {}
}

const NavigationModule = getModule(NavigationState);

export { NavigationModule };
